export const BOOKS_MISSING_ANSWERS_REPORT_LOADING = 'LOADING';
export const BOOKS_MISSING_ANSWERS_REPORT_SUCCESS = 'SUCCESS';
export const BOOKS_MISSING_ANSWERS_REPORT_ERROR = 'ERROR';
